'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FilterCell = exports.RightPaddingCell = exports.LeftPaddingCell = exports.TopPaddingCell = exports.BottomPaddingCell = exports.PaddingCell = exports.DimensionLabelCell = exports.DimensionEmptyCell = exports.DimensionGrandTotalCell = exports.DimensionSubTotalCell = exports.ColumnAxisCell = exports.RowAxisCell = exports.TotalCell = exports.SubTotalCell = exports.PlainValueCell = exports.TextValueCell = exports.ValueCell = exports.TextCell = exports.NumberCell = exports.TableCell = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _PivotTableUtils = require('./PivotTableUtils');

var _uuid = require('d2-utilizr/lib/uuid');

var _uuid2 = _interopRequireDefault(_uuid);

var _PivotTableConstants = require('../table/PivotTableConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var cellClsMap = _defineProperty({}, _PivotTableConstants.TOTAL_CELL, {
    totalAggregationType: _defineProperty({}, _PivotTableConstants.NA_AGGREGATION_TOTAL, 'aggtype-na')
});

var cellTitleMap = _defineProperty({}, _PivotTableConstants.TOTAL_CELL, {
    totalAggregationType: _defineProperty({}, _PivotTableConstants.NA_AGGREGATION_TOTAL, 'Irrelevant total - sum across aggregation types')
});

var cellDisplayValueMap = _defineProperty({}, _PivotTableConstants.TOTAL_CELL, {
    totalAggregationType: _defineProperty({}, _PivotTableConstants.NA_AGGREGATION_TOTAL, '-')
});

var getFromCellMap = function getFromCellMap(map, type, prop, value) {
    return type in map && prop in map[type] && value in map[type][prop] && map[type][prop][value];
};

var TableCell = exports.TableCell = function TableCell() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, TableCell);

    this.collapsed = false;
    this.hidden = false;
    this.empty = false;
    this.colSpan = 1;
    this.rowSpan = 1;
    this.width = 120;
    this.height = 25;
    this.style = '';

    _extends(this, config);
};

var NumberCell = exports.NumberCell = function (_TableCell) {
    _inherits(NumberCell, _TableCell);

    function NumberCell(value, displayValue, config) {
        _classCallCheck(this, NumberCell);

        var _this = _possibleConstructorReturn(this, (NumberCell.__proto__ || Object.getPrototypeOf(NumberCell)).call(this, config));

        _this.value = value;
        _this.displayValue = displayValue;
        // this.displayValue = getDefaultNumberDisplayValue(displayValue, config.skipRounding);

        _this.title = _this.displayValue;
        return _this;
    }

    return NumberCell;
}(TableCell);

var TextCell = exports.TextCell = function (_TableCell2) {
    _inherits(TextCell, _TableCell2);

    function TextCell(displayValue, config) {
        _classCallCheck(this, TextCell);

        var _this2 = _possibleConstructorReturn(this, (TextCell.__proto__ || Object.getPrototypeOf(TextCell)).call(this, config));

        _this2.displayValue = typeof displayValue !== 'string' && typeof displayValue !== 'number' ? '&nbsp;' : displayValue;
        _this2.title = _this2.displayValue;
        return _this2;
    }

    return TextCell;
}(TableCell);

var ValueCell = exports.ValueCell = function (_NumberCell) {
    _inherits(ValueCell, _NumberCell);

    function ValueCell(value, displayValue, config) {
        _classCallCheck(this, ValueCell);

        var _this3 = _possibleConstructorReturn(this, (ValueCell.__proto__ || Object.getPrototypeOf(ValueCell)).call(this, value, displayValue, config));

        _this3.type = _PivotTableConstants.VALUE_CELL;
        _this3.cls = 'pivot-value';

        _this3.isValue = true;
        _this3.uuid = (0, _uuid2.default)();
        return _this3;
    }

    return ValueCell;
}(NumberCell);

var TextValueCell = exports.TextValueCell = function (_ValueCell) {
    _inherits(TextValueCell, _ValueCell);

    function TextValueCell(value, displayValue, config) {
        _classCallCheck(this, TextValueCell);

        var _this4 = _possibleConstructorReturn(this, (TextValueCell.__proto__ || Object.getPrototypeOf(TextValueCell)).call(this, value, displayValue, config));

        _this4.displayValue = displayValue;

        _this4.cls += ' align-left cursor-default';
        return _this4;
    }

    return TextValueCell;
}(ValueCell);

var PlainValueCell = exports.PlainValueCell = function (_NumberCell2) {
    _inherits(PlainValueCell, _NumberCell2);

    function PlainValueCell(value, displayValue, config) {
        _classCallCheck(this, PlainValueCell);

        var _this5 = _possibleConstructorReturn(this, (PlainValueCell.__proto__ || Object.getPrototypeOf(PlainValueCell)).call(this, value, displayValue, config));

        _this5.type = _PivotTableConstants.VALUE_CELL;
        _this5.cls = 'pivot-value';
        return _this5;
    }

    return PlainValueCell;
}(NumberCell);

var SubTotalCell = exports.SubTotalCell = function (_NumberCell3) {
    _inherits(SubTotalCell, _NumberCell3);

    function SubTotalCell(value, displayValue, config) {
        _classCallCheck(this, SubTotalCell);

        var _this6 = _possibleConstructorReturn(this, (SubTotalCell.__proto__ || Object.getPrototypeOf(SubTotalCell)).call(this, value, displayValue, config));

        _this6.type = _PivotTableConstants.SUB_TOTAL_CELL;
        _this6.cls = 'pivot-value-subtotal';
        return _this6;
    }

    return SubTotalCell;
}(NumberCell);

;

var TotalCell = exports.TotalCell = function (_NumberCell4) {
    _inherits(TotalCell, _NumberCell4);

    function TotalCell(value, displayValue, config) {
        _classCallCheck(this, TotalCell);

        var _this7 = _possibleConstructorReturn(this, (TotalCell.__proto__ || Object.getPrototypeOf(TotalCell)).call(this, value, displayValue, config));

        _this7.type = _PivotTableConstants.TOTAL_CELL;
        _this7.cls = 'pivot-value-total-subgrandtotal';


        var aggTypeCls = getFromCellMap(cellClsMap, _this7.type, 'totalAggregationType', config.totalAggregationType);
        aggTypeCls && (_this7.cls += ' ' + aggTypeCls);

        var aggTypeTitle = getFromCellMap(cellTitleMap, _this7.type, 'totalAggregationType', config.totalAggregationType);
        aggTypeTitle && (_this7.title += ' (' + aggTypeTitle + ')');

        var aggTypeDisplayValue = getFromCellMap(cellDisplayValueMap, _this7.type, 'totalAggregationType', config.totalAggregationType);
        aggTypeDisplayValue && (_this7.displayValue = aggTypeDisplayValue);
        return _this7;
    }

    return TotalCell;
}(NumberCell);

;

var RowAxisCell = exports.RowAxisCell = function (_TextCell) {
    _inherits(RowAxisCell, _TextCell);

    function RowAxisCell(displayValue, config) {
        _classCallCheck(this, RowAxisCell);

        var _this8 = _possibleConstructorReturn(this, (RowAxisCell.__proto__ || Object.getPrototypeOf(RowAxisCell)).call(this, displayValue, config));

        _this8.type = _PivotTableConstants.DIMENSION_CELL;
        _this8.cls = 'pivot-dim pivot-row-dim td-nobreak';
        _this8.axis = 'row';


        if (_this8.showHierarchy) {
            _this8.csl += ' align-left';
        }
        return _this8;
    }

    return RowAxisCell;
}(TextCell);

var ColumnAxisCell = exports.ColumnAxisCell = function (_TextCell2) {
    _inherits(ColumnAxisCell, _TextCell2);

    function ColumnAxisCell(displayValue, config) {
        _classCallCheck(this, ColumnAxisCell);

        var _this9 = _possibleConstructorReturn(this, (ColumnAxisCell.__proto__ || Object.getPrototypeOf(ColumnAxisCell)).call(this, displayValue, config));

        _this9.type = _PivotTableConstants.DIMENSION_CELL;
        _this9.cls = 'pivot-dim pivot-col-dim';
        _this9.axis = 'column';


        if (_this9.sort) {
            _this9.cls += ' td-sortable';
        }
        return _this9;
    }

    return ColumnAxisCell;
}(TextCell);

var DimensionSubTotalCell = exports.DimensionSubTotalCell = function (_TextCell3) {
    _inherits(DimensionSubTotalCell, _TextCell3);

    function DimensionSubTotalCell(displayValue, config) {
        _classCallCheck(this, DimensionSubTotalCell);

        var _this10 = _possibleConstructorReturn(this, (DimensionSubTotalCell.__proto__ || Object.getPrototypeOf(DimensionSubTotalCell)).call(this, displayValue, config));

        _this10.type = _PivotTableConstants.DIMENSION_SUB_TOTAL_CELL;
        _this10.cls = 'pivot-dim-subtotal';
        return _this10;
    }

    return DimensionSubTotalCell;
}(TextCell);

var DimensionGrandTotalCell = exports.DimensionGrandTotalCell = function (_TextCell4) {
    _inherits(DimensionGrandTotalCell, _TextCell4);

    function DimensionGrandTotalCell(value, displayValue, config) {
        _classCallCheck(this, DimensionGrandTotalCell);

        var _this11 = _possibleConstructorReturn(this, (DimensionGrandTotalCell.__proto__ || Object.getPrototypeOf(DimensionGrandTotalCell)).call(this, value, displayValue, config));

        _this11.type = _PivotTableConstants.DIMENSION_TOTAL_CELL;
        _this11.cls = 'pivot-dim-total';


        if (_this11.sort) {
            _this11.cls += ' td-sortable';
        }

        if (_this11.generateUuid) {
            _this11.uuid = (0, _uuid2.default)();
        }
        return _this11;
    }

    return DimensionGrandTotalCell;
}(TextCell);

var DimensionEmptyCell = exports.DimensionEmptyCell = function (_TextCell5) {
    _inherits(DimensionEmptyCell, _TextCell5);

    function DimensionEmptyCell(config) {
        _classCallCheck(this, DimensionEmptyCell);

        var _this12 = _possibleConstructorReturn(this, (DimensionEmptyCell.__proto__ || Object.getPrototypeOf(DimensionEmptyCell)).call(this, '&nbsp;', config));

        _this12.type = _PivotTableConstants.EMPTY_CELL;
        _this12.cls = 'pivot-empty';
        return _this12;
    }

    return DimensionEmptyCell;
}(TextCell);

var DimensionLabelCell = exports.DimensionLabelCell = function (_TextCell6) {
    _inherits(DimensionLabelCell, _TextCell6);

    function DimensionLabelCell(displayValue, config) {
        _classCallCheck(this, DimensionLabelCell);

        var _this13 = _possibleConstructorReturn(this, (DimensionLabelCell.__proto__ || Object.getPrototypeOf(DimensionLabelCell)).call(this, displayValue, config));

        _this13.type = _PivotTableConstants.LABELED_CELL;
        _this13.cls = 'pivot-dim-label';
        _this13.axis = 'row';
        return _this13;
    }

    return DimensionLabelCell;
}(TextCell);

var PaddingCell = exports.PaddingCell = function (_TableCell3) {
    _inherits(PaddingCell, _TableCell3);

    function PaddingCell(config) {
        _classCallCheck(this, PaddingCell);

        var _this14 = _possibleConstructorReturn(this, (PaddingCell.__proto__ || Object.getPrototypeOf(PaddingCell)).call(this, config));

        _this14.type = _PivotTableConstants.PADDING_CELL;
        _this14.displayValue = '&nbsp;';
        return _this14;
    }

    return PaddingCell;
}(TableCell);

var BottomPaddingCell = exports.BottomPaddingCell = function (_PaddingCell) {
    _inherits(BottomPaddingCell, _PaddingCell);

    function BottomPaddingCell(heightInPixels, config) {
        _classCallCheck(this, BottomPaddingCell);

        var _this15 = _possibleConstructorReturn(this, (BottomPaddingCell.__proto__ || Object.getPrototypeOf(BottomPaddingCell)).call(this, config));

        _this15.cls = 'pivot-padding bottom-padding';


        _this15.hidden = heightInPixels <= 0;
        _this15.height = heightInPixels;
        return _this15;
    }

    return BottomPaddingCell;
}(PaddingCell);

var TopPaddingCell = exports.TopPaddingCell = function (_PaddingCell2) {
    _inherits(TopPaddingCell, _PaddingCell2);

    function TopPaddingCell(heightInPixels, config) {
        _classCallCheck(this, TopPaddingCell);

        var _this16 = _possibleConstructorReturn(this, (TopPaddingCell.__proto__ || Object.getPrototypeOf(TopPaddingCell)).call(this, config));

        _this16.cls = 'pivot-padding top-padding';


        _this16.hidden = heightInPixels <= 0;
        _this16.height = heightInPixels;
        return _this16;
    }

    return TopPaddingCell;
}(PaddingCell);

var LeftPaddingCell = exports.LeftPaddingCell = function (_PaddingCell3) {
    _inherits(LeftPaddingCell, _PaddingCell3);

    function LeftPaddingCell(widthInPixels, config) {
        _classCallCheck(this, LeftPaddingCell);

        var _this17 = _possibleConstructorReturn(this, (LeftPaddingCell.__proto__ || Object.getPrototypeOf(LeftPaddingCell)).call(this, config));

        _this17.cls = 'pivot-padding left-padding';


        _this17.hidden = widthInPixels <= 0;
        _this17.width = widthInPixels;
        return _this17;
    }

    return LeftPaddingCell;
}(PaddingCell);

var RightPaddingCell = exports.RightPaddingCell = function (_PaddingCell4) {
    _inherits(RightPaddingCell, _PaddingCell4);

    function RightPaddingCell(widthInPixels, config) {
        _classCallCheck(this, RightPaddingCell);

        var _this18 = _possibleConstructorReturn(this, (RightPaddingCell.__proto__ || Object.getPrototypeOf(RightPaddingCell)).call(this, config));

        _this18.cls = 'pivot-padding right-padding';


        _this18.hidden = widthInPixels <= 0;
        _this18.width = widthInPixels;
        return _this18;
    }

    return RightPaddingCell;
}(PaddingCell);

var FilterCell = exports.FilterCell = function (_TableCell4) {
    _inherits(FilterCell, _TableCell4);

    function FilterCell(displayValue, colSpan, config) {
        _classCallCheck(this, FilterCell);

        var _this19 = _possibleConstructorReturn(this, (FilterCell.__proto__ || Object.getPrototypeOf(FilterCell)).call(this, config));

        _this19.type = _PivotTableConstants.FILTER_CELL;
        _this19.cls = 'pivot-filter cursor-default';


        _this19.displayValue = displayValue;
        _this19.colSpan = colSpan;
        return _this19;
    }

    return FilterCell;
}(TableCell);
//# sourceMappingURL=PivotTableCells.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/table/PivotTableCells.js
 ** module id = 198
 ** module chunks = 0 1
 **/